import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Lerato M.",
    role: "Trustee · Acacia Park Body Corporate",
    location: "Sandton, Gauteng",
    rating: 5,
    text:
      "Greenroute brought order to what felt like an endless list of maintenance issues. The reports they hand us each month make our AGM almost easy. A genuine partner.",
  },
  {
    name: "Pieter v.d. Westhuizen",
    role: "Managing Agent · Coastline Estates",
    location: "Cape Town, Western Cape",
    rating: 5,
    text:
      "We manage twelve schemes and Greenroute is the team I trust with the most complex ones. Transparent pricing, vetted contractors, and they actually pick up the phone after hours.",
  },
  {
    name: "Nomvula K.",
    role: "Chairperson · Umhlanga Heights",
    location: "uMhlanga, KwaZulu-Natal",
    rating: 5,
    text:
      "Their preventative plan caught a roof issue before it became a six-figure problem. The team is professional, polite to residents, and meticulously documented.",
  },
  {
    name: "Sipho D.",
    role: "Property Owner · Multiple sites",
    location: "Gqeberha, Eastern Cape",
    rating: 5,
    text:
      "One point of contact across all my properties has been a game-changer. Greenroute treats every job — small or large — with the same level of care.",
  },
];

const testimonials_data_end = true;
// NOTE: JSON-LD Review/AggregateRating schema intentionally NOT emitted while
// these are sample/placeholder testimonials — Google Rich Results policy
// requires real, attributable reviews. Re-enable once real client reviews land.

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-36 bg-cream"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="uppercase text-xs tracking-[0.3em] text-sage mb-6">
              In their words
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest leading-[1.05] tracking-tight">
              The mark of trust —
              <br />
              from the people we <span className="italic">serve.</span>
            </h2>
          </div>
          <p className="lg:col-span-4 lg:col-start-9 text-graphite text-base md:text-lg leading-relaxed">
            We are proud of every estate we look after. Here's what trustees,
            managing agents and owners say about working with Greenroute.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-testid="testimonials-grid">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
              className="bg-white border border-bordersoft p-8 md:p-10 flex flex-col gap-6 group hover:border-forest transition-colors duration-500"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center justify-between">
                <Quote size={28} strokeWidth={1.25} className="text-gold shrink-0" />
                <div className="flex gap-1" aria-label={`${t.rating} out of 5 stars`}>
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star
                      key={idx}
                      size={14}
                      className={idx < t.rating ? "fill-gold text-gold" : "text-bordersoft"}
                      strokeWidth={1.5}
                    />
                  ))}
                </div>
              </div>
              <blockquote className="font-serif text-2xl md:text-3xl text-ink leading-snug">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-auto pt-6 border-t border-bordersoft">
                <div className="font-medium text-ink">{t.name}</div>
                <div className="text-sm text-graphite mt-1">{t.role}</div>
                <div className="uppercase text-[10px] tracking-[0.25em] text-sage mt-2">
                  {t.location}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-[11px] uppercase tracking-[0.25em] text-sage/70">
            Sample testimonials · Replace with real client reviews
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
